import styled from "styled-components";

import * as colors from "src/styles/constants/colors";

export const FieldValue = styled.div<{ old?: boolean }>`
  word-break: break-word;
  white-space: pre-line;
  ${(props) =>
    props.old &&
    `
    text-decoration: line-through;
    color: ${colors.grey18};
  `}
`;

export const NewValue = styled.span`
  display: flex;
  word-break: break-word;
  white-space: pre-line;
  > span {
    font-weight: initial;
  }
  > div > a > span > span {
    display: initial;
  }
`;

export const OldValue = styled(NewValue)`
  color: ${colors.grey18};
  text-decoration: line-through;
  > span {
    text-decoration: line-through;
  }
  > div > a > span > span {
    text-decoration: line-through;
  }
`;
